import React, {Component} from "react";
import {Drawer, message} from "antd";
import Loader from "../../../Common/Component/Loader";
import {isEmpty, map} from "lodash";
import {CloseOutlined} from '@ant-design/icons';
import * as yup from "yup";

class Resource extends Component {
  state = {
    list: {},
    loader: false,
    addResource: {},
    isEdit: false,
    deleteResources: [],
    item_name: '',
    item_quantity: '',
    item_uuid: '',
    item_index: '',
    errors: {}
  }

  componentDidMount = () => {
    const {customerId, getResourceList} = this.props;
    if (customerId) {
      this.setState({loader: true})
      getResourceList({user__uuid: customerId}) //get resource list
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const {list} = this.state;
    // message.destroy();

    // get list of resources
    if (Object.keys(nextProps?.Resource?.list).length > 0 && JSON.stringify(nextProps?.Resource?.list) !== JSON.stringify(list)) {
      this.setState({list: nextProps?.Resource?.list})
      this.setState({loader: false});
    }

    // add resource
    // if (Object.keys(nextProps?.Resource?.addResource).length > 0 && JSON.stringify(nextProps?.Resource?.addResource) !== JSON.stringify(addResource)) {
    //   this.setState({addResource: nextProps?.Resource?.addResource, list: {...list, results: [...(list?.results || []), nextProps?.Resource?.addResource]}})
    // }
  }

  // on resource detail change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value })
  }

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    console.log(((!isNaN(value) && reg.test(value)) || value === '' || value === '-'))
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // toggle edit
  toggleEdit = (item, index) => {
    this.setState({isEdit: true, item_index: index, item_uuid: item?.uuid, item_name: item?.item_name, item_quantity: item?.item_quantity})
  }

  // on delete resource
  onDelete = (item, index) => {
    const {list, deleteResources} = this.state;
    let idx = index;
    if (item.uuid) {deleteResources.push(item.uuid); idx = list?.results?.findIndex(obj => obj.uuid === item.uuid)}
    if (idx > -1) {list.results.splice(idx, 1); this.setState({list, deleteResources})}
  }

  // on add resource
  onAddItem = () => {
    const {item_name, item_quantity, list} = this.state;
    list.results.push({item_name, item_quantity,
      user_uuid: this.props.customerId, user: {
        uuid: JSON.parse(localStorage.getItem('authUser'))?.user?.uuid
      }})
    this.onClear();
  }

  // on edit resource
  onEditItem = () => {
    const {item_name, item_quantity, list, item_uuid, item_index} = this.state;
    const idx = item_uuid ? list?.results?.findIndex(obj => obj.uuid === item_uuid) : item_index;
    list.results[idx] = {uuid: item_uuid || '', item_name, item_quantity,
      user_uuid: this.props.customerId, user: {
        uuid: JSON.parse(localStorage.getItem('authUser'))?.user?.uuid
      }}
    this.onClear();
  }

  // on Update
  onUpdate = () => {
    const {addResource, deleteResource, updateResource} = this.props;
    const {list, deleteResources} = this.state;
    let arr = [];
    this.setState({loader: true})
    map(list?.results, (obj) => {
      if (obj.uuid) arr.push(updateResource(obj))
      else arr.push(addResource(obj)) // add resource
    })
    map(deleteResources, (uuid) => arr.push(deleteResource(uuid))) // delete resource

    Promise.all(arr).then(response => {
      if (!isEmpty(response)) {
        setTimeout(() => {
          this.props.closeDrawer();
        }, 1500)
      }
    })
  }

  // on clear
  onClear = () => {
    this.setState({item_name: '', item_quantity: '', item_uuid: '', isEdit: false, errors: {}})
  }

  // validation
  validate = (action) => {
    const {item_name, item_quantity} = this.state;
    setTimeout(() => {
      const schema = yup.object().shape({
        item_name: yup.string().required("Item name is required"),
        item_quantity: yup.string().required("Quantity is required"),
      })

      const data = { item_name, item_quantity };
      schema.validate(data, { abortEarly: false }).then(() => {
        this.setState({is_btn_active: true, errors: {}})
        if (action === 'save') this.onAddItem()
        else if (action === 'edit') this.onEditItem()
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => {err_data[item.path] = item.message})
        this.setState({errors: err_data, is_btn_active: false})
      });
    }, 500);
  }

  render() {
    const {closeDrawer, openDrawer, selectedRow} = this.props;
    const {loader, list, item_name, item_quantity, isEdit, errors} = this.state;
    return (
      <Drawer
        placement={'right'}
        closable={false}
        onClose={closeDrawer}
        visible={openDrawer}
        key={'right'}
        width={'400'}
        className="drawer-wrapper"
      >
        <div className="rdrawer filter_drawer_wrapper">
          {loader && <Loader/>}
          <div className="card-row flex-column">
            <div className="card-full">
              <div className="flex ai-center mb-30">
                <h4 className="mb-0">{`${selectedRow?.management_company} Resources`}</h4>
                <CloseOutlined onClick={closeDrawer}/>
              </div>
              {/* resource List */}
              {
                map(list?.results, (item, index) => {
                  return (
                    <div key={`reources${item.uuid}`}>
                      <div className={"flex"}>
                        <labe><b>{item?.item_name}</b></labe>
                        <a className="success float-right" href={'/#'} onClick={(e) => {e.preventDefault(); this.toggleEdit(item, index)}}><u>Edit</u></a>
                      </div>
                      <div className="flex">
                        <labe><b>Quantity: {item?.item_quantity}</b></labe>
                        <a className="red float-right" href={'/#'} onClick={(e) => {e.preventDefault(); this.onDelete(item, index)}}><u>Remove</u></a>
                      </div>
                    </div>
                  )
                })
              }
            </div>
            <hr/>
            <div className="card-full">
              <div className={"flex"}>
                <div>
                  <h4>{isEdit ? 'Edit Item' : 'New Item'}</h4>
                </div>
                <div>
                  <a className="success float-right"  href={'/#'} onClick={(e) => {e.preventDefault(); this.onClear()}}><u>Clear</u></a>
                </div>
              </div>

              <div className="form-group">
                <div className="fitem">
                  <input
                    name="item_name"
                    type="text"
                    placeholder={'Item Name'}
                    value={item_name}
                    onChange={(e) => this.onTextChange(e)}
                  />
                  {errors?.['item_name'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['item_name']}</label> : ''}
                </div>

                <div className="fitem">
                  <input
                    name="item_quantity"
                    type="text"
                    placeholder={'Quantity'}
                    value={item_quantity}
                    onChange={(e) => this.onNumericInputChange(e.target.value) && this.onTextChange(e)}
                  />
                  {errors?.['item_quantity'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['item_quantity']}</label> : ''}
                </div>

                {isEdit ? <button
                  // type="submit"
                  className={`btn btn-full btn-bdr`}
                  // disabled={!is_btn_active}
                  onClick={() => this.validate('edit')}>Edit Item</button> :
                  <button
                    // type="submit"
                    className={`btn btn-full btn-bdr`}
                    // disabled={!is_btn_active}
                    onClick={() => this.validate('save')}>Add Item</button>
                }
              </div>
            </div>
          </div>
          <div className="footer">
            <button className={`btn btn-bdr`} onClick={closeDrawer}>Cancel</button>
            <button
              // type="submit"
              className={`btn btn-warning`}
              onClick={() => this.onUpdate()}>
              Update
            </button>
          </div>
        </div>
      </Drawer>
    );
  }
}

export default Resource